import { animate } from 'motion';

const animatedVec = document.querySelectorAll('.animated-vec');

animatedVec.forEach(container => {
  const animVec = container.querySelectorAll('.anim-vec');

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        animVec.forEach((vec, i) => {
          if (entry.isIntersecting) {
            animate(
              vec,
              {
                opacity: [0, 1],
              },
              {
                // duration: 0.8,
                duration: 0.5,
                delay: 0.7 + i * 0,
                easing: 'ease-out',
              }
            );
          } else {
            animate(
              vec,
              {
                opacity: [1, 0],
              },
              {
                duration: 0.3,
                delay: i * 0,
                easing: 'ease',
              }
            );
          }
        });
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(container);
});
